import { Button, CollapsedContent, SelectGroup } from '@aqarmap/aqarmap-ui';
import { SelectListType } from '@aqarmap/aqarmap-ui/dist/types/components/SelectGroup/types';
import Modal from '~/components/Modal';
import { CloneListingUnitType } from '~addListing/types';
import { useTranslation } from 'react-i18next';

const CloneUnitsModal = ({
  title,
  units,
  selectedUnitId,
  onSelectUnit,
  onSkip,
  onClone,
  isCloneLoading,
  isSkipLoading,
}: {
  title: string;
  units: CloneListingUnitType[];
  selectedUnitId: number | null;
  onSelectUnit: (unitId: number | null) => void;
  onSkip: () => void;
  onClone: () => void;
  isCloneLoading: boolean;
  isSkipLoading: boolean;
}) => {
  const { t } = useTranslation('app');

  const unitsList: SelectListType[] = units.map((unit) => {
    return {
      field: {
        value: String(unit.id),
        checked: selectedUnitId === unit.id,
        id: unit.id.toString(),
      },
      label: {
        component: (
          <label
            className="flex justify-between gap-2x w-full"
            htmlFor={unit.id.toString()}
          >
            <span className="text-body_1 text-gray__dark_2">
              {unit.area} {t('meter')}
            </span>
            <span className="text-body_2 text-gray__dark_2">
              {unit.price?.toLocaleString()}
            </span>
          </label>
        ),
      },
    };
  });

  const Footer = () => (
    <div className="flex w-full gap-1.5x">
      <Button
        variant="primary"
        size="medium"
        className="flex-1 rounded-[26px]"
        onClick={onClone}
        isLoading={isCloneLoading}
        disabled={isCloneLoading || isSkipLoading}
      >
        {t('clone')}
      </Button>
      <Button
        variant="secondary"
        size="medium"
        className="flex-1 rounded-[26px]"
        onClick={onSkip}
        isLoading={isSkipLoading}
        disabled={isCloneLoading || isSkipLoading}
      >
        {t('skip')}
      </Button>
    </div>
  );

  return (
    <Modal
      modalKey="cloneUnitsModal"
      title={title}
      Footer={<Footer />}
      scrolled
    >
      <div className="flex flex-col gap-3x ">
        <p className="text-body_2 text-gray__dark_2">
          {t('cloneUnitsModalDescription')}
        </p>
        {units.length === 0 ? (
          <p className="text-body_2 text-gray__dark_2">{t('noResults')}</p>
        ) : (
          <CollapsedContent
            maxLines={5}
            itemHeight={24}
            itemsGap={12}
            btnClassName="mt-1.5x"
            text={{ less: t('showLess'), more: t('showMore') }}
          >
            <SelectGroup
              size="medium"
              name="cloneUnit"
              list={unitsList}
              handleChange={(_e, value: string) =>
                onSelectUnit(
                  selectedUnitId === Number(value) ? null : Number(value),
                )
              }
              className="w-full"
              label={{ text: t('choseUnit'), className: 'text-link' }}
            />
          </CollapsedContent>
        )}
      </div>
    </Modal>
  );
};

export default CloneUnitsModal;
